const coerceToInt = (num: string): number => parseInt(num.replace(/\D/g, ''));

/**
 * Ensures that the provided version is at least the required version.
 *
 * @param versionUnderTest A provided semver to test.
 * @param versionRequired The minimum required version.
 */

const isVersionAtLeast = (versionUnderTest: string, versionRequired: string): boolean => {
    const versionUnderTestSegments = versionUnderTest.split('.').map(coerceToInt);
    const versionRequiredSegments = versionRequired.split('.').map(coerceToInt);
    const maxSegments = Math.min(versionUnderTestSegments.length, versionRequiredSegments.length);

    for (let i = 0; i < maxSegments; i++) {
        const segmentUnderTest = versionUnderTestSegments[i];
        const segmentRequired = versionRequiredSegments[i];

        if (segmentUnderTest > segmentRequired) {
            return true;
        }

        if (segmentUnderTest < segmentRequired) {
            return false;
        }
    }

    return versionUnderTestSegments.length >= versionRequiredSegments.length;
};

export default isVersionAtLeast;
